import { render, staticRenderFns } from "./Wp_jd_home_test.vue?vue&type=template&id=7fde14d3&"
import script from "./Wp_jd_home_test.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_home_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports